import { Component, EventEmitter, inject, Input, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SipStatusLabelComponent } from "../sip-status-label/sip-status-label.component";
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { SipService } from 'src/app/shared/services/sip/sip.service';
import { IUser } from 'src/app/shared/models';
import { DialogService } from 'src/app/shared/components/dialog/service/dialog.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-banner-multisip-detail-card',
  standalone: true,
  imports: [
    CommonModule, 
    SipStatusLabelComponent,
    MatIconModule
  ],
  templateUrl: './banner-multisip-detail-card.component.html',
  styleUrls: ['./banner-multisip-detail-card.component.scss']
})
export class BannerMultisipDetailCardComponent {
  @Input() activeSipSubscribed;
  router = inject(Router);
  sipService = inject(SipService);
  dialogService = inject(DialogService);

  @ViewChild('requestSuccessfulRef') requestSuccessfulRef: any;

  @Output() emitOnResumeSip = new EventEmitter();
  
  onPledgeMoreClick(index: any) {
    const currency = this.activeSipSubscribed[index].currency;
    const amount = this.activeSipSubscribed[index].amount;
    const newAmount = this.sipService.getPledgeAmt(currency, amount);
    this.router.navigate(['new/pledge-more'], {queryParams: {
      pr:'pledge',
      amt: newAmount,
      pledgeAmt: amount,
      src: '',
      sip_cause: this.activeSipSubscribed[index].campaign_cause,
      pledge_more: 1
    }, queryParamsHandling: 'merge'});
  }

  onUpdatePayment(index: number) {
    const userData: IUser = JSON.parse(localStorage.getItem('userdata')) as IUser;
    const onDemandSubs = userData['latest_subscription'];
    if (onDemandSubs?.isOnDemandSubscription && this.activeSipSubscribed[index].label !== 'LAPSED' && this.activeSipSubscribed[index].label !== 'CANCELLED') {
      let url = environment.sipretention_domain;
      url += '/' + this.activeSipSubscribed[index].campaign_cause + 'cause';
      window.location.href = url;
    } else {
      this.router.navigate(['new/sip/change-payment'], {queryParams: {pr: 'c', email: userData.email, sip_cause: this.activeSipSubscribed[index].campaign_cause}})
    }
  }
  
  getBtnLabel(index) {
    const obj = {
      'NEW': () => `Pledge More`,
      'PAUSED': () => 'Resume Now',
      'LAPSED': () => 'Restart SIP',
      'CANCELLED': () => 'Restart SIP'
    } 
    return obj[this.activeSipSubscribed[index].label]() || '';
  }

  onResume(index: any) {
    const userData: IUser= JSON.parse(localStorage.getItem('userdata'));
    if (this.activeSipSubscribed[index].label === 'PAUSED') {
      this.sipService.resumePausedSip(userData.id, this.activeSipSubscribed[index].latestorder.subscription_id, {
        status: 1,
        month: ''
      }).subscribe({
        next: (data) => {
          this.openThanksDialog();
          this.emitOnResumeSip.emit(true);
        }
      })
    } else if (['LAPSED', 'CANCELLED'].includes(this.activeSipSubscribed[index].label)) {
      const userData: IUser = JSON.parse(localStorage.getItem('userdata')) as IUser;
      const latestOrder = userData['latest_order'];
      if (latestOrder?.ondemandSubscription && this.activeSipSubscribed[index].label !== 'LAPSED') {
        let url = environment.sipretention_domain;
        url += '/' + this.activeSipSubscribed[index].campaign_cause + 'cause';
        window.location.href = url;
      } else {
        this.router.navigate(['new/sip/change-payment'], {queryParams: {pr: 'c', email: userData.email, sip_cause: this.activeSipSubscribed[index].campaign_cause}})      
      }
    }
  }


  openThanksDialog() {
    this.dialogService.openDialogViaTemplate(this.requestSuccessfulRef, {
      width: '400px',
      height: 'auto',
      panelClass: 'sip-resume-dialog'
    });
  }
}
